export default {
    set_answers: (state, payload) => state.answers = payload,
    set_answer: (state, payload) => state.answer = payload,
    set_claim: (state, payload) => state.claim = payload,
    set_claims: (state, payload) => state.claims = payload,
    set_claim_filters: (state, payload) => state.claim_filters = payload,
    set_modal_view_claim: (state, payload) => state.modal_view_claim = payload,
}